import React, { useEffect, useState } from 'react'
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useComparison } from '../../../context/ComparisonContext';
import VariantDetailRow from '../VariantDetailRow';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        width: '24%'
    },
}));

export default function OverviewTable() {
    const { comparisions } = useComparison();
    const [rows, setRows] = useState(null);

    useEffect(() => {
        const rows = comparisions.map((item) => {
            return item.variants.filter((variant) => variant.variantid === item.variant);
        });
        setRows(rows);
    }, [comparisions])

    const getValue = (value, unit = "") => value === "-" ? "--" : value + " " + unit;

    if (rows) {
        return (
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell className='react-table-heading'>Overview</StyledTableCell>
                            {rows.map((row) => (
                                <StyledTableCell className='react-table-heading' align="center" key={row[0].variantid}>{row[0].variantid}</StyledTableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <VariantDetailRow title="Fuel Type" values={
                            [getValue(rows[0][0].variantfueltype),
                            getValue(rows[1][0].variantfueltype),
                            (rows[2]) && getValue(rows[2][0].variantfueltype)
                            ]
                        } />

                        <VariantDetailRow title="Mileage (ARAI)" values={
                            [
                                getValue(rows[0][0].arai_mileage, rows[0][0].concat_with_units),
                                getValue(rows[1][0].arai_mileage, rows[1][0].concat_with_units),
                                (rows[2]) && getValue(rows[2][0].arai_mileage, rows[2][0].concat_with_units)
                            ]
                        } />

                        <VariantDetailRow title="Fuel Tank Capacity" values={
                            [getValue(rows[0][0].fuel_tank_capacity, "Litres"),
                            getValue(rows[1][0].fuel_tank_capacity, "Litres"),
                            (rows[2]) && getValue(rows[2][0].fuel_tank_capacity, "Litres")
                            ]
                        } />

                        <VariantDetailRow title="Seating Capacity" values={
                            [getValue(rows[0][0].seating_capacity),
                            getValue(rows[1][0].seating_capacity),
                            (rows[2]) && getValue(rows[2][0].seating_capacity)
                            ]
                        } />

                        <VariantDetailRow title="Transmission Type" values={
                            [getValue(rows[0][0].transmission_type),
                            getValue(rows[1][0].transmission_type),
                            (rows[2]) && getValue(rows[2][0].transmission_type)
                            ]
                        } />

                        <VariantDetailRow title="Engine Displacement (cc)" values={
                            [getValue(rows[0][0].engine_displacement_cc, "cc"),
                            getValue(rows[1][0].engine_displacement_cc, "cc"),
                            (rows[2]) && getValue(rows[2][0].engine_displacement_cc, "cc")
                            ]
                        } />
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
}
